import axios from 'axios';
import logger from '../utils/logger';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      
      const currentToken = localStorage.getItem('access_token');
      if (currentToken) {
        try {
          logger.log('Token expired, attempting refresh...');

          // JWT refresh en Lumen requiere el token actual en headers
          const response = await axios.post(`${API_BASE_URL}/auth/refresh`, {}, {
            headers: {
              'Authorization': `Bearer ${currentToken}`,
              'Content-Type': 'application/json'
            }
          });

          const { token } = response.data;

          if (token) {
            localStorage.setItem('access_token', token);
            logger.log('Token refreshed successfully');

            // Retry original request with new token
            original.headers.Authorization = `Bearer ${token}`;
            return api(original);
          } else {
            throw new Error('No token received from refresh endpoint');
          }
        } catch (refreshError) {
          logger.error('Token refresh failed:', refreshError?.response?.data || refreshError.message);

          // Clear all auth data
          localStorage.removeItem('access_token');
          localStorage.removeItem('user');

          // Don't redirect if we're already on the login page
          if (!window.location.pathname.includes('/auth/login')) {
            logger.log('Redirecting to login...');
            window.location.href = '/auth/login';
          }
        }
      } else {
        // No token, clear storage and redirect to login
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');
        
        if (!window.location.pathname.includes('/auth/login')) {
          window.location.href = '/auth/login';
        }
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;